import React, { Component } from "react";
import AuthTopNav from "../containers/TopNav/AuthTopNav";

import Footer from "../containers/Footer";

import Conversation from "../containers/messaging/Conversation";
class MessageDetails extends Component {
  render() {
    return (
      <div className="app-wrapper message-details has-mobile-navbar">
        <AuthTopNav />

        <section className="gray-bg">
          <div className="main-container">
            <div className="content-wrapper">
              <div className="custom-card message-details-container">
                <Conversation conversationGuid={this.props.match.params.conversationGuid} includeHeader={true} />
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}

export default MessageDetails;
